/* =========================================================================================
  File Name:
  Description:
  ----------------------------------------------------------------------------------------
  Item Name: GetBoarded UI Template
  Author: GetBoarded
  Author URL: https://www.getboarded.com
========================================================================================== */


import state from './moduleAddSkillState.js'
import mutations from './moduleAddSkillMutations.js'
import actions from './moduleAddSkillActions.js'
import getters from './moduleAddSkillGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
